var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { onMultiple } from "@rentiohq/shared-frontend/dist/redux/utils/reducer.utils";
import * as authActions from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.actions";
import { createReducer } from "redux-act";
import * as systemActions from "./system.actions";
import { EPreferencePersistScope } from "./system.types";
export var REDUCER_KEY_SYSTEM_LOCAL = "systemLocal";
var getDefaultState = function () { return ({
    preferences: {},
    preferencesLocalStorage: {},
    lastModified: undefined,
    isFetchingIndexDate: false,
    fetchingIndexDateError: undefined,
}); };
var reducer = createReducer({}, getDefaultState());
onMultiple(reducer, [
    authActions.signOutStart.type,
    authActions.signInAutomaticallyStart.type,
    authActions.setAccessTokensWithoutSideEffectsStart.type,
], function (state) { return (__assign(__assign({}, getDefaultState()), { lastModified: state.lastModified, preferencesLocalStorage: {
        RENTIO_INTERNAL: state.preferencesLocalStorage.RENTIO_INTERNAL,
    } })); });
reducer.on(systemActions.getRemotePreferences.types.SUCCESS, function (state, _a) {
    var preferences = _a.preferences;
    return (__assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), preferences) }));
});
/**
 * `null` removes a preference rather than storing one, the way the API's
 * preference store treats it. Kept as a literal here, it would hide the
 * default from every selector, which only falls back on a missing key
 * (DEV-3343).
 */
var withPreferences = function (params) {
    var current = params.current, changes = params.changes;
    var result = __assign({}, current);
    Object.entries(changes).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value === null) {
            delete result[key];
        }
        else {
            result[key] = value;
        }
    });
    return result;
};
reducer.on(systemActions.setPreferences, function (state, _a) {
    var persistScope = _a.persistScope, preferences = _a.preferences;
    return (__assign(__assign({}, state), { preferences: withPreferences({
            current: state.preferences,
            changes: persistScope !== EPreferencePersistScope.LocalStorage
                ? preferences
                : {},
        }), preferencesLocalStorage: withPreferences({
            current: state.preferencesLocalStorage,
            changes: persistScope === EPreferencePersistScope.LocalStorage
                ? preferences
                : {},
        }) }));
});
reducer.on(systemActions.getIndexLastModified.types.START, function (state) { return (__assign(__assign({}, state), { isFetchingIndexDate: true })); });
reducer.on(systemActions.getIndexLastModified.types.SUCCESS, function (state, _a) {
    var headers = _a.headers;
    return (__assign(__assign({}, state), { lastModified: headers["last-modified"], isFetchingIndexDate: false, fetchingIndexDateError: undefined }));
});
reducer.on(systemActions.getIndexLastModified.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isFetchingIndexDate: false, fetchingIndexDateError: error }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
